import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function LoginPage() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const url =
      "https://script.google.com/macros/s/AKfycbzYUVY6NQAyI-9BSHu7lih1wWQ5V7W5hJdpJU8AxaWNUqFB1INJ-T5nqg9z7qnepldK/exec?email=" +
      encodeURIComponent(email) +
      "&password=" +
      encodeURIComponent(password);

    try {

      const response = await fetch(url);
      const data = await response.json();

      if (data.status === "success") {

        const role = data.role.toLowerCase();

        if (role === "admin") {
          navigate("/admin-dashboard");
        }
        else if (role === "doctor") {
          navigate("/doctor-dashboard");
        }

      } else {
        alert("Invalid Email or Password");
      }

    } catch (error) {
      alert("Server Error. Try again.");
    }
  };

  // ✅ BACK BUTTON
  const handleBack = () => {
    navigate(-1); // go to previous page
  };

  return (

    <div
      style={{
        backgroundColor: "#F6F5F2",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >

      <div
        className="p-4 shadow-sm"
        style={{
          width: "100%",
          maxWidth: "400px",
          
          backgroundColor: "white",
          borderRadius: "12px"
        }}
      >

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          
          <button
            onClick={handleBack}
            className="btn btn-sm"
            style={{
              backgroundColor: "rgb(123, 74, 28)",
              color: "white"
            }}
          >
            ← Back
          </button>

          <h5 style={{ color: "#9b2226", margin: 0 }}>
           Login
          </h5>

          <div></div>
        </div>

        {/* FORM */}
        <form onSubmit={handleLogin}>

          <input
            type="email"
            className="form-control mb-3"
            placeholder="Enter Email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            style={{ borderRadius: "8px" }}
          />

          <input
            type="password"
            className="form-control mb-3"
            placeholder="Enter Password"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            style={{ borderRadius: "8px" }}
          />

          <button
            className="btn w-100"
            style={{
              backgroundColor: "#9b2226",
              color: "white",
              borderRadius: "8px"
            }}
          >
            Login
          </button>

        </form>

      </div>

    </div>
  );
}

export default LoginPage;